export default __webpack_public_path__ + "resources/icons/d121-1298.png";